<p-dialog
  [attr.data-testid]="testId || 'confirmation-dialog'"
  [(visible)]="visible"
  [header]="title | translate"
  [modal]="true"
  [style]="dialogStyle"
  [draggable]="false"
  [resizable]="false"
  [closable]="canClose"
  [closeOnEscape]="canClose"
  (onHide)="onDialogHide()"
>
  <div
    data-testid="confirmation-dialog-content"
    class="confirmation-dialog-content"
  >
    @if (message && !hasCustomContent) {
      <p data-testid="confirmation-dialog-message" class="confirmation-message">
        {{ message | translate }}
      </p>
    }
    @if (hasCustomContent) {
      <ng-content></ng-content>
    }
    @if (buttons && buttons.length > 0) {
      <div
        data-testid="confirmation-dialog-actions"
        class="confirmation-actions"
      >
        @for (button of buttons; track button.action) {
          <app-button
            [testId]="'confirmation-btn-' + button.action"
            [label]="button.label | translate"
            [type]="getButtonType(button)"
            [outlined]="button.outlined || false"
            [loading]="button.loading || false"
            [disabled]="button.disabled || button.loading || false"
            (emitOnClick)="onClick(button.action)"
          ></app-button>
        }
      </div>
    }
  </div>
</p-dialog>
